export default "__VITE_ASSET__CpB7t4oL__"